import { DeliveryDialogShell } from '../components/composite/delivery_dialog/delivery_dialog_shell/DeliveryDialogShell';
import { Texts } from '../components/composite/delivery_dialog/texts/Texts';
import { GoBackButton } from '../components/atomic/buttons/go_back_button/GoBackButton';
import { DeliveryItemImage } from '../components/atomic/delivery_items/DeliveryItemImage';
import type { ScreenViewProps } from '../shared/screenViewProps';
import { OpenedDeliveryItemBackground } from '../success_delivery_screen/content/OpenedDeliveryItemBackground';
import { Button } from './button/Button';
import { HideDeliveryItemImage } from './content/HideDeliveryItemImage';
import { HeaderText } from './header_text/HeaderText';
import type { NewDeliveryScreenController } from './NewDeliveryScreenController';
import type { NewDeliveryScreenModel } from './NewDeliveryScreenModelScreen';
import './new_delivery_screen.css';

export type NewDeliveryScreenViewProps = ScreenViewProps<
  NewDeliveryScreenModel,
  NewDeliveryScreenController
>;

export function NewDeliveryScreenView({
  model,
  controller,
}: NewDeliveryScreenViewProps) {
  return (
    <DeliveryDialogShell
      className="new-delivery-screen"
      giantName={model.giantId}
      giantIconVariant="badge"
      header={<HeaderText />}
      content={
        <>
          <Texts
            riddleText={model.riddleText}
            deliveryItemText={model.deliveryItemText}
            showDeliveryItem={model.revealItem}
            levelNameText={model.levelNameText}
            giantNameText={model.giantNameText}
          />
          {model.revealItem ? (
            <>
              <OpenedDeliveryItemBackground />
              <DeliveryItemImage
                giantId={model.giantId}
                orderIndex={model.orderIndex}
                placement="new-delivery"
              />
            </>
          ) : (
            <HideDeliveryItemImage />
          )}
        </>
      }
      actions={
        <>
          <GoBackButton onClick={controller.handleGoBack} />
          <Button
            onClick={controller.handleTakeOrder}
            disabled={!model.canTakeOrder}
          />
        </>
      }
    />
  );
}
